/* BAF Saat — hareket: kademeli belirme ve kroki çizimi. prefers-reduced-motion'da hiçbir şey yapmaz. */
(() => {
  const azHareket = window.matchMedia('(prefers-reduced-motion: reduce)');

  const hazirla = (kok = document) => {
    const belirenler = kok.querySelectorAll('.bs-belir:not(.is-gorundu)');
    const krokiler = kok.querySelectorAll('.bs-kroki[data-ciz-scroll]:not(.is-ciziliyor)');

    if (azHareket.matches || !('IntersectionObserver' in window)) {
      belirenler.forEach((el) => el.classList.add('is-gorundu'));
      return;
    }

    krokiler.forEach((kroki) => {
      kroki.querySelectorAll('[data-ciz]').forEach((yol) => {
        if (typeof yol.getTotalLength === 'function') {
          yol.style.setProperty('--bs-ciz-uzunluk', Math.ceil(yol.getTotalLength()));
        }
      });
    });

    const gozcu = new IntersectionObserver(
      (girdiler) => {
        girdiler.forEach((g) => {
          if (!g.isIntersecting) return;
          const el = g.target;
          if (el.classList.contains('bs-kroki')) el.classList.add('is-ciziliyor');
          else el.classList.add('is-gorundu');
          gozcu.unobserve(el);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }
    );

    belirenler.forEach((el) => gozcu.observe(el));
    krokiler.forEach((el) => gozcu.observe(el));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => hazirla());
  else hazirla();

  /* Tema düzenleyicide bölüm yeniden yüklenince */
  document.addEventListener('shopify:section:load', (e) => hazirla(e.target));
  window.bsHareketHazirla = hazirla;

  /* Parallax: büyük fotoğraf bantlarında görsel kaydırmaya göre ±24 px kayar (CSS translate; hover scale'ini bozmaz). */
  const PX_SECICI = '.bs-mbant__foto img, .bs-slogan__foto img, .bs-secili__foto img, .bs-kol-bas__gorsel img';
  const PX_MENZIL = 24;
  let pxListe = [];
  let pxBekliyor = false;
  const pxGuncelle = () => {
    pxBekliyor = false;
    const vh = window.innerHeight;
    pxListe.forEach((img) => {
      const r = img.parentElement.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      const oran = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2); /* -1 … 1 */
      const menzil = Math.min(PX_MENZIL, r.height * 0.035); /* scale 1.08 → kenar başına %4 pay; boşluk açılmaz */
      img.style.setProperty('--bs-px', (Math.max(-1, Math.min(1, oran)) * -menzil).toFixed(1) + 'px');
    });
  };
  const pxIste = () => { if (!pxBekliyor) { pxBekliyor = true; requestAnimationFrame(pxGuncelle); } };
  const pxHazirla = () => {
    if (azHareket.matches) return;
    pxListe = [...document.querySelectorAll(PX_SECICI)];
    pxListe.forEach((img) => img.classList.add('bs-px'));
    pxIste();
  };
  window.addEventListener('scroll', pxIste, { passive: true });
  window.addEventListener('resize', pxIste);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pxHazirla);
  else pxHazirla();
  document.addEventListener('shopify:section:load', pxHazirla);
})();
